import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction,toJS} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import ExportRow from "./ExportRow";
import {checkbox, custom} from "../../utils/linker";
import ExportResult from "./ExportResult";

function Export(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  console.log('compStore.category_fields', toJS(compStore.category_fields), toJS(compStore.export_fields));

  if(!compStore.category_fields.inited || !compStore.export_fields.length) {
    return null;
  }

  return (
    <div className="pbottom20">
      <div className="up12 margin">
        <div className="cell s-auto">
          <h2>Какие поля экспортировать?</h2>
        </div>
        <div className="cell s-shrink s-top">
          <span className="fs32 mdi mdi-close b1 pointer" onClick={()=>{ compStore.closeExport(); }}></span>
        </div>
      </div>

      <div className={`vpadd5 solid1-bottom bo-w2 bg-w2 bold w5`}>
        <div className="up12 margin pointer">
          <div className="cell s-shrink pleft5">
            <label>
              <input checked={compStore.isAllSelected()}
                     onChange={(e)=>{
                       if(e.target.checked) {
                         compStore.selectAll();
                       } else {
                         compStore.unselectAll();
                       }
                     }}
                     id={`chk`}
                     type="checkbox"
              /><span></span>
            </label>
          </div>
          <div className="cell s-4">
            Название
          </div>
          <div className="cell s-4">
            Код
          </div>
          <div className="cell s-auto">

          </div>
        </div>
      </div>
      {compStore.export_fields.map((item, index)=>{
        return (
          <ExportRow key={index} {...custom(compStore.export_fields, index)} />
        )
      })}
      <div className="up12 margin ptop20">
        <div className="cell s-auto"></div>
        <div className="cell s-shrink vpadd10 ">

          <div className="pbottom10">
            <label>
              <span className="vam dib"><input type="checkbox" {...checkbox(compStore.export_options, 'use_order')}/><span></span></span> <span className="vam dib">Использовать текущую сортироку</span>
            </label>
          </div>
          <div className="pbottom10">
            <label>
              <span  className="vam dib"><input type="checkbox" {...checkbox(compStore.export_options, 'use_filter')}/><span></span></span> <span className="vam dib">Использовать текущий фильтр</span>
            </label>
          </div>
        </div>

        <div className="cell s-12 tar">
          <ExportResult />
        </div>

        <div className="cell s-auto"></div>
        <div className="cell s-shrink">
          <span className="btn2" onClick={()=>{ compStore.closeExport(); }}><span>Отмена</span></span>
        </div>
        <div className="cell s-shrink">
          <span className="btn1" onClick={()=>{ compStore.exportData(); }}><span>Экспортировать</span></span>
        </div>
      </div>
    </div>
  )
};

Export.defaultProps = {};

Export.propTypes = {}

export default observer(Export);
